export const floorAreaRatioList = [
    {
        id: 0,
        value: '指定なし'
    },
    {
        id: 30,
        value: '30%'
    },
    {
        id: 50,
        value: '50%'
    },
    {
        id: 80,
        value: '80%'
    },
    {
        id: 100,
        value: '100%'
    },
    {
        id: 150,
        value: '150%'
    },
    {
        id: 200,
        value: '200%'
    },
    {
        id: 250,
        value: '250%'
    },
    {
        id: 300,
        value: '300%'
    },
    {
        id: 350,
        value: '350%'
    },
    {
        id: 400,
        value: '400%'
    },
    {
        id: 450,
        value: '450%'
    },
    {
        id: 500,
        value: '500%'
    },
    {
        id: 600,
        value: '600%'
    },
    {
        id: 700,
        value: '700%'
    },
    {
        id: 800,
        value: '800%'
    },
    {
        id: 900,
        value: '900%'
    },
    {
        id: 1000,
        value: '1000%'
    }
]